import type { Artwork } from 'src/services/apollo/generated/graphql'

type ArtworkVideoExtra = {
  i2vProParameters?: {
    generateAudio?: boolean | null
  } | null
  referenceVideoParameters?: {
    generateAudio?: boolean | null
  } | null
}

export function getArtworkVideoHasAudio(extra: Artwork['extra']) {
  const videoExtra = extra as ArtworkVideoExtra | null | undefined

  return Boolean(
    videoExtra?.i2vProParameters?.generateAudio ??
    videoExtra?.referenceVideoParameters?.generateAudio,
  )
}
